/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { textPostTextMd5Verify } from "../../funcs/textPostTextMd5Verify.js";
import { PostTextMd5VerifyRequest$zodSchema } from "../../models/posttextmd5verifyop.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: PostTextMd5VerifyRequest$zodSchema,
};

export const tool$textPostTextMd5Verify: ToolDefinition<typeof args> = {
  name: "text-post-text-md5-verify",
  description: `MD5 校验

下载了一个文件，想确认它在传输过程中有没有损坏？校验MD5值是最常用的方法。

## 功能概述
你提供原始文本和一个MD5哈希值，我们帮你计算文本的哈希，并与你提供的哈希进行比对，告诉你它们是否匹配。这在文件完整性校验等场景下非常有用。`,
  scopes: ["read"],
  annotations: {
    "title": "",
    "destructiveHint": false,
    "idempotentHint": false,
    "openWorldHint": true,
    "readOnlyHint": true,
  },
  args,
  tool: async (client, args, ctx) => {
    const [result] = await textPostTextMd5Verify(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    return formatResult(result.value);
  },
};
